import { fields } from ".";
import { change, reset } from "redux-form";
import MyForm from "components/templates/MyForm";
import { useAppDispatch } from "redux/hooks";
import { carMovementActions } from "redux/slices/carMovement";
import { config } from "config";
import { smartActions } from "redux/slices/smart";
import { useEffect } from "react";


function DriverLocationTrackingFilters() {
	const form = "CalendarFiltersForm";
	const dispatch = useAppDispatch();
	const partnerID = config.APP_ENV === 'Production' ? { value: "63ea0b28c32eebbb57a7cc5e", label: "Yelo Limousine" } : { value: "64fb1c9937a2a1b4fa9b908a", label: "Progomania" };

	const onClickReset = () => {
		dispatch(reset(form));
		dispatch(change(form, "partner_id", partnerID));
		dispatch(smartActions.resetCalendarFilters());
	};
	useEffect(() => {
		dispatch(change(form, "partner_id", partnerID));
	}, [dispatch]);


	const handleSubmit = (values: any) => {
		let data: any = {};
		const {
			zone,
			drivers,
			page_size,
			address,
			partner_id,
		} = values;


		if (address && address?.length > 0) data.address = address.map((item: any) => item.value);
		if (zone && zone?.length > 0) data.zone_ids = zone.map((item: any) => item.value);
		if (drivers && drivers.length > 0) data.driver_ids = drivers.map((item: any) => item.value);
		if (partner_id) data.partner_id = partner_id.value;
		if (page_size) data.page_size = Number(page_size);

		delete data.zone;
		delete data.drivers;

		dispatch(smartActions.setCalendarFilters(data))
	};

	return (
		<div className="filters">
			<MyForm
				form={form}
				myFields={fields}
				onSubmit={handleSubmit}
				onClickReset={onClickReset}
			/>
		</div>
	);
}

export default DriverLocationTrackingFilters; 